import {
  addClause,
  conditionNames,
  deleteMatchingClauses,
  filterAudienceTargetingClauses,
  propertyOperators
} from "@appcues/libcues";
import { defaultOperators } from "constants/account/conditions";
import {
  filterUrlTargetingClauses,
  filterPropertyClauses
} from "utils/conditions";
import { replaceClauseBranch } from "transforms/clauses";

export function setDisplayAnyPage(clauses) {
  return addClause(
    deleteMatchingClauses(clauses, filterUrlTargetingClauses),
    null,
    {
      conditionName: conditionNames.URL,
      operator: propertyOperators.REGEX,
      value: ".*"
    }
  );
}

export function setDisplaySpecificPage(_clauses, replacementClauses) {
  let clauses = deleteMatchingClauses(_clauses, filterUrlTargetingClauses);
  if (replacementClauses) {
    clauses = replaceClauseBranch(clauses, replacementClauses);
  } else {
    clauses = addClause(clauses, null, {
      conditionName: conditionNames.URL,
      operator: defaultOperators.CONTAINS,
      value: ""
    });
  }
  return clauses;
}

export function setAudienceAllUsers(clauses) {
  return deleteMatchingClauses(clauses, filterAudienceTargetingClauses);
}

export function setAudienceSegment(clauses, segmentId) {
  return addClause(
    deleteMatchingClauses(clauses, filterAudienceTargetingClauses),
    null,
    {
      conditionName: conditionNames.SEGMENTS,
      segment: segmentId
    }
  );
}

export function setAudienceCustomSegment(
  _clauses,
  replacementClauses,
  defaultProperty = ""
) {
  let clauses = deleteMatchingClauses(_clauses, filterAudienceTargetingClauses);
  if (replacementClauses) {
    clauses = replaceClauseBranch(clauses, replacementClauses);
  } else {
    clauses = addClause(clauses, null, {
      conditionName: conditionNames.PROPERTIES,
      property: defaultProperty,
      operator: propertyOperators.CONTAINS,
      value: ""
    });
  }
  return clauses;
}

export function setChecklistFlowCompleted(clauses, flowId) {
  return addClause(
    deleteMatchingClauses(clauses, filterPropertyClauses),
    null,
    {
      conditionName: conditionNames.CONTENT,
      content: flowId
    },
    false
  );
}

export function setDefaultPropertyClause(clauses) {
  return addClause(
    deleteMatchingClauses(clauses, filterPropertyClauses),
    null,
    {
      conditionName: conditionNames.PROPERTIES,
      property: "",
      operator: propertyOperators.CONTAINS,
      value: ""
    },
    false
  );
}

export function getGoalIdFromRule(rule = {}) {
  if (!ruleHasGoal(rule)) {
    return null;
  }

  return rule.goals[0];
}

export function ruleHasGoal(rule = {}) {
  if (!rule) {
    return false;
  }

  return rule.goals && Array.isArray(rule.goals) && rule.goals[0];
}
